import Plyr from 'plyr';
import 'plyr/dist/plyr.css'

const videoBlock = () => {
	const elements = document.querySelectorAll('.content-block--video');
	if (!elements) return;

	elements.forEach((element) => {
		const plyrElement = element.querySelector('.plyr__video-embed');

		if (plyrElement) {
			const player = new Plyr(plyrElement, {
				controls: [
					'play-large',
					'progress',
					'current-time',
					'mute',
					'volume',
					'fullscreen'
				]
			});
		}
	});
}

export default videoBlock;
